import conflictFields, { ConflictFields } from '../../constants/conflictFields';

const conflictFieldsLabel: Record<ConflictFields, string> = {
  [conflictFields.ACTIVITIES]: 'Activities',
  [conflictFields.ADDRESS]: 'Address',
  [conflictFields.ALTERNATIVE_BENEFICIAL_OWNERS]: 'Alternative beneficial owners',
  [conflictFields.BENEFICIAL_OWNER]: 'Beneficial owner',
  [conflictFields.BENEFICIAL_OWNERS]: 'Beneficial owners',
  [conflictFields.CITIZENSHIP]: 'Citizenship',
  [conflictFields.CITY]: 'City',
  [conflictFields.COMPANY_NAME]: 'Company name',
  [conflictFields.DATE_OF_BIRTH]: 'Date of birth',
  [conflictFields.EMAIL]: 'Email',
  [conflictFields.EMPLOYMENT_STATUS]: 'Employment status',
  [conflictFields.FIRST_NAME]: 'Firstname',
  [conflictFields.FORECASTED_TURNOVER]: 'Forecasted yearly turnover',
  [conflictFields.INCOME]: 'Monthly income',
  [conflictFields.INDUSTRY]: 'Industry',
  [conflictFields.IS_FINANCIAL_INSTITUTION]: 'Is it a financial institution?',
  [conflictFields.LAST_NAME]: 'Lastname',
  [conflictFields.LEGAL_FORM]: 'Legal form of business',
  [conflictFields.LISTED_FINANCIAL_MARKET]: 'Is listed on financial market?',
  [conflictFields.MERCHANT_CATEGORY_CODE]: 'Merchant Category Code (MCC)',
  [conflictFields.MIDDLE_NAME]: 'Middle name',
  [conflictFields.OPERATION_START_DATE]: 'Date the business started operating',
  [conflictFields.OTHER_LEGAL_FORM]: 'Other legal form of business',
  [conflictFields.OWNER_STRUCTURE]: 'Owner structure',
  [conflictFields.PEP]: 'PEP',
  [conflictFields.PHONE_NUMBER]: 'Phone number',
  [conflictFields.POSTAL_CODE]: 'Postcode',
  [conflictFields.PREVIOUS_TURNOVER]: 'Previous yearly turnover',
  [conflictFields.PRODUCTS]: 'Products',
  [conflictFields.PURPOSE]: 'Purpose',
  [conflictFields.REGISTRATION_NUMBER]: 'Company registration number',
  [conflictFields.RESIDENCE]: 'Country of residence',
  [conflictFields.ROLE]: 'Role',
  [conflictFields.SIGNATORIES]: 'Signatories',
  [conflictFields.SOURCE_OF_FUNDS]: 'Source of funds',
  [conflictFields.SOURCE_OF_WEALTH]: 'Source of wealth',
  [conflictFields.STATE_OWNED]: 'Is state owned?',
  [conflictFields.TAX_RESIDENCY]: 'Tax residency',
  [conflictFields.TIN]: 'Tax identification number (TIN)',
  [conflictFields.TRANSACTION_MONITORING_THRESHOLD]: 'Transaction monitoring thresholds',
  [conflictFields.WEBSITE]: 'Website',
  // [conflictFields.PERSONAL_NUMBER]: 'Personal number',
} as const;

export default conflictFieldsLabel;
